import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import { Box } from '@mui/material';
import { ContextualMenu } from './ContextualMenu';
import { EditableImage } from './EditableImage/EditImage';
import { EditablePrice } from './EditPrice/EditPrice';
import { ProductUi } from './ProductUi';

export const itemGenerator = (item: ProductUi) => {
  return [
    <>
      <Box>#{item.productNumber}</Box>
    </>,
    <>
      <Box>{item.seller}</Box>
    </>,
    <>
      <EditableImage
        productId={item.productId}
        skuId={item.skuId}
        image={item.image}
      />
    </>,
    <>
      <Box>{item.name}</Box>
    </>,
    <>
      <Box>{item.presentation}</Box>
    </>,
    <>
      <EditablePrice
        price={item.price}
        productId={item.productId}
        skuId={item.skuId}
      />
    </>,
    <>
      <Box>{item.status && <StatusBadge badge={item.status} />}</Box>
    </>,
    <>
      <ContextualMenu product={item} />
    </>,
  ];
};
